import { PropsWithChildren } from 'react';
import Button, { ButtonProps } from '~/components/buttons/NewButton';
import IconPlus from '~/icons/icon-plus.svg?react';

type Props = Omit<ButtonProps, 'variant' | 'icon'>;

const AddControlButton: React.FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
  return (
    <Button variant="link" Icon={IconPlus} {...props}>
      {children}
    </Button>
  );
};

export default AddControlButton;
